























import { GQL_productListSearch_products } from '@/queries/__generated__/productListSearch';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ProductShow from './ProductShow.vue';

@Component({
  components: {
    ProductShow,
  },
})
export default class ProductShowButton extends Vue {
  @Prop() public product!: GQL_productListSearch_products;
  public showDialog = false;
}
